"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfRegisterDto = instanceOfRegisterDto;
exports.RegisterDtoFromJSON = RegisterDtoFromJSON;
exports.RegisterDtoFromJSONTyped = RegisterDtoFromJSONTyped;
exports.RegisterDtoToJSON = RegisterDtoToJSON;
exports.RegisterDtoToJSONTyped = RegisterDtoToJSONTyped;
/**
 * Check if a given object implements the RegisterDto interface.
 */
function instanceOfRegisterDto(value) {
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('password' in value) || value['password'] === undefined)
        return false;
    if (!('phone' in value) || value['phone'] === undefined)
        return false;
    if (!('countryId' in value) || value['countryId'] === undefined)
        return false;
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    return true;
}
function RegisterDtoFromJSON(json) {
    return RegisterDtoFromJSONTyped(json, false);
}
function RegisterDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'email': json['email'],
        'password': json['password'],
        'phone': json['phone'],
        'countryId': json['countryId'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'visitorId': json['visitorId'] == null ? undefined : json['visitorId'],
    };
}
function RegisterDtoToJSON(json) {
    return RegisterDtoToJSONTyped(json, false);
}
function RegisterDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'email': value['email'],
        'password': value['password'],
        'phone': value['phone'],
        'countryId': value['countryId'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'visitorId': value['visitorId'],
    };
}
